import { render } from "./KeyMapper.vue?vue&type=template&id=bac9fab4"
import script from "./KeyMapper.vue?vue&type=script&lang=js"
export * from "./KeyMapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__